<template>
    <datepicker class="form-control" :format="format" v-model="value" :minimum-view="minimumView" :disabledDates="disabledDates"  @selected="onSelect" :disabled="disabled"></datepicker>
</template>

<script>
    import Datepicker from 'vuejs-datepicker';
    import {formatDate, parseDate} from '@/shared/utils';
    export default {
        props: {
            date: {
                type: String
            },
            format: {
                type: String,
                default: 'dd/MM/yyyy'
            },
            minimumView: {
                type: String,
                default: 'day'
            },
            disabledDates: {
                type: Object,
            },
            disabled: {
              type: Boolean,
              default: false
            }
        },
        name: "CustomDatePicker",
        components: {
            Datepicker
        },
        data() {
            return {
                value: '',
            }
        },
        methods: {
            onSelect(date) {
                // this.$emit('change', formatDate(date));
                this.$emit('input', formatDate(date));
            }
        },
        created() {

        },
        watch: {
            // Watch for value change
            date: {
                immediate: true,
                // handle the changed value
                handler(val) {
                    if (val) {
                        this.value = parseDate(this.date);
                    }
                }
            }
        }
    }
</script>

<style scoped>

</style>